/**
 * Provides helper functions.
 */
import Intl from 'intl';
import 'intl/locale-data/jsonp/en-ZA.js';

import { CENTS_IN_RAND } from './constants';

export enum UnitType {
  Cents,
  Rands,
}

/**
 * Formats a given amount according to the unit type.
 *
 * @param amount - Amount to format.
 * @param unitType - Optional unit to apply formatting with.
 * @returns A raw formatted value.
 */
export function formatValue(amount: number, unitType: UnitType = UnitType.Cents) {
  return unitType === UnitType.Cents ? amount / CENTS_IN_RAND : amount;
}
/**
 * Formats a given value as a user-friendly currency.
 *
 * @param amount - Amount to format.
 * @param unitType - Optional unit to apply formatting with.
 *
 * @returns User-friendly representation of the amount.
 */
export function formatCurrency(amount: number, unitType: UnitType = UnitType.Cents) {
  const { NumberFormat } = Intl;
  const value = formatValue(amount, unitType);

  return new NumberFormat('en-ZA', {
    currency: 'ZAR',
    currencyDisplay: 'symbol',
    minimumFractionDigits: 2,
    style: 'currency',
  })
    .format(value)
    .replace(',', '.')
    .replace(/\D00$/, '');
}
